import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";

const AboutTeam = ({ sectionRef }) => {
  const { t } = useTranslation();

  return (
    <section className="py-20" data-testid="team-section" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="section-header">
          <span className="text-[#E07A5F] font-medium tracking-wider uppercase text-sm">
            {t("about.team.badge")}
          </span>
          <h2 className="mt-3">{t("about.team.title")}</h2>
          <p>{t("about.team.subtitle")}</p>
        </div>
        <div className="flex justify-center">
          <Card
            className="reveal stagger-1 bg-white border-0 overflow-hidden card-lift max-w-md w-full"
            data-testid="team-card-chef"
          >
            <div className="h-96 img-hover-zoom">
              <img
                src="/chef-sophie.jpg"
                alt={t("about.team.chef.name")}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <CardContent className="p-6 text-center">
              <h3 className="text-xl font-semibold text-[#3D405B] mb-1 font-['Playfair_Display']">
                {t("about.team.chef.name")}
              </h3>
              <p className="text-[#E07A5F] font-medium text-sm mb-3">
                {t("about.team.chef.role")}
              </p>
              <p className="text-[#6B705C] text-sm">{t("about.team.chef.bio")}</p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default AboutTeam;
